module.exports = __webpack_public_path__ + "static/media/project-kaguya.dcea5380.jpg";